import React, { useState } from 'react';
import { FormContainer } from '../../AdminRoutes/CreateRoutes/CreateForm.styles';
import BreadCrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import CompanyManagerSignUp from './SignupManager/SignupManager.component';
import CompanyInfo from './CompanyInfo/CompanyInfo.component';
import CompanyAddress from './CompanyAddress/CompanyAddress.component';
import ResultModal from '../../Components/Modal/ResultModal.component';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import CompanySignupProgressBar from './ProgressBar/ProgressBar.component';
import Info from './Info/Info.component';
import CompanySignupReview from './SignUpCompanySubmit/SignupSubmit.component';
// import PageHeader from '../../Components/PageHeader/PageHeader.component';

const STEPS = {
  MANAGER: 0,
  COMPANY: 1,
  ADDRESS: 2,
  REVIEW: 3,
};

const CompanySignupPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [result, setResult] = useState('');

  const [company, setCompany] = useState({
    companyName: '',
    mainContact: '',
    secondaryContact: '',
    email: '',
    phoneOffice: '',
    phoneMobile: '',
    website: '',
    notes: '',
    secondaryEmail: '',
    secondaryPhone: '',
    industry: '',
  });

  const [billingAddress, setBillingAddress] = useState({
    street: '',
    city: '',
    province: '',
    postalCode: '',
  });

  const [user, setUser] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    password: '',
    verifyPassword: '',
    type: 'Manager',
    sendCertificateToMe: false,
  });

  const [step, setStep] = useState(STEPS.MANAGER);

  return (
    <>
      <HelmetHelper
        title="Create a Company Account"
        description="Create a company account to manage employees, training, course assignments, and workplace safety certifications."
        noIndex
      />

      <FormContainer>
        <BreadCrumbs
          one="Login"
          oneLink="/login"
          two="Create Company Account"
        />

        {/* <PageHeader
          eyebrow="Company Account Setup"
          title="Create Your Company Account"
          desc="Set up your manager account first, then tell us about your company. You can complete additional company details and add employees later."
        /> */}

        <CompanySignupProgressBar step={step} onStepClick={setStep} />

        {step === STEPS.MANAGER && (
          <>
            <h2>Step 1</h2>
            <CompanyManagerSignUp
              user={user}
              setUser={setUser}
              setStep={setStep}
            />
          </>
        )}

        {step === STEPS.COMPANY && (
          <>
            <h2>Step 2</h2>

            <Info />
            <CompanyInfo
              company={company}
              setCompany={setCompany}
              setStep={setStep}
            />
          </>
        )}

        {step === STEPS.ADDRESS && (
          <>
            <h2>Step 3</h2>
            <CompanyAddress
              billingAddress={billingAddress}
              setBillingAddress={setBillingAddress}
              setStep={setStep}
            />
          </>
        )}

        {step === STEPS.REVIEW && (
          <>
            <h2>Step 4</h2>
            <CompanySignupReview
              company={company}
              user={user}
              billingAddress={billingAddress}
              setStep={setStep}
              setResult={setResult}
              setIsOpen={setIsOpen}
            />
          </>
        )}
      </FormContainer>

      <ResultModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        result={result}
        linkTo="/login"
        span="Login"
      />
    </>
  );
};

export default CompanySignupPage;
